/**
 * Skip Navigation Link
 *
 * Allows keyboard users to skip repetitive navigation and jump straight to
 * main content. Visually hidden until focused.
 *
 * Part of Tech Stack Opportunity Analysis Item 3e:
 * "Accessibility enhancements"
 *
 * @usage
 * ```tsx
 * // In AppLayout.tsx, before the sidebar:
 * <SkipNav />
 *
 * // On the main content area:
 * <main id="main-content" tabIndex={-1}>
 * ```
 */

export function SkipNav({ contentId = 'main-content' }: { contentId?: string }) {
  return (
    <a
      href={`#${contentId}`}
      className="
        fixed top-0 left-0 z-[9999]
        -translate-y-full focus:translate-y-0
        bg-primary text-primary-foreground
        px-4 py-2 text-sm font-medium
        transition-transform duration-150
        focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
      "
    >
      Skip to main content
    </a>
  );
}
